
import { authenticatedFetch } from "../Auth/Auth";
 import { getCurrentConfig } from '../../config/config';
 
 const config = getCurrentConfig();




export const getOpenhomes = async (spanOfDays = 0, propertyId = 0) => {
    let spanOfDaysQs = '';
    let propertyIdQs = '';
    if( parseInt(spanOfDays) > 0){
      spanOfDaysQs = `?spanOfDays=${spanOfDays}`;
    }
     if( parseInt(propertyId) > 0){
      propertyIdQs = `&propertyId=${propertyId}`;
    }

   

    const response = await authenticatedFetch(`${config.API_BASE_URL}/opentimes${spanOfDaysQs}${propertyIdQs}`, {
        method: 'GET',
        headers: {
        
          'Content-Type': 'application/json',
          'User-Agent': 'agentApp/1.0',
        }
      });

      if (response.ok) {
        const responseData = await response.json();
        return responseData; 
      } else {
        throw new Error(`Error getting openhomes`);
      }




};


export const getPreviousOpenhomes = async (spanOfPreviousDays = 0) => {
  let spanOfPreviousDaysQs = '';
  if( parseInt(spanOfPreviousDays) > 0){
    spanOfPreviousDaysQs = `?spanOfPreviousDays=${spanOfPreviousDays}`;
  }

 

  const response = await authenticatedFetch(`${config.API_BASE_URL}/opentimes${spanOfPreviousDaysQs}`, {
      method: 'GET',
      headers: {
      
        'Content-Type': 'application/json',
        'User-Agent': 'agentApp/1.0',
      }
    });

    if (response.ok) {
      const responseData = await response.json();
      return responseData; 
    } else {
      throw new Error(`Error getting previous openhomes`);
    }




};



export const getOpenhomesDetails = async (opentimeID) => {
 

  const response = await authenticatedFetch(`${config.API_BASE_URL}/opentimesDetails/${opentimeID}`, {
      method: 'GET',
      headers: {
      
        'Content-Type': 'application/json',
        'User-Agent': 'agentApp/1.0',
      }
    });
    
    if (response.ok) {
      const responseData = await response.json();
      return responseData; 
    } else {
      throw new Error(`Error getting openhome details`);
    }




};